import { Map } from 'immutable';

import { getObject, setObject } from '@/services/localStorage';
import { mergeTournamentsPriority } from 'nike-ui/src/components/notification-popup/reframe/h&s';
import { Active } from 'nike-ui/src/components/tournaments/TournamentStatus';

export const sortTournaments = db => {
    let tournaments = db.getIn(['tournaments', 'tournaments', 'byIds'], Map());
    const alreadyShown = getObject('alreadyShownTournaments') || [];
    const ready = tournaments.filter(tournament => !alreadyShown.includes(tournament.get('id')));
    const alreadyShownActive = getObject('alreadyShownActiveTournaments') || [];
    const starting = tournaments.filter(tournament => !alreadyShownActive.includes(tournament.get('id')));
    return mergeTournamentsPriority(db, ready, starting);
};
export const changeStatusOfNotificationPopup = (id, status) => db => {
    const key = status === Active ? 'alreadyShownActiveTournaments' : 'alreadyShownTournaments';
    const old = getObject(key);
    setObject(key, old ? [...old, id] : [id]);
    return db.updateIn(['tournaments', 'showPopup'], old => !old);
};
